import React, { useState, useRef, useEffect } from 'react';
import { logo } from '../assets/svg/logo.js'
import { sidebar_svg } from '../assets/svg/sidebar.js'
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import '../assets/css/sidebar.css';
import { menus } from '../helper/staticHelper.js'
import { clearComposeBox } from '../helper/commonHelper.js'
import { QuickSent, Category } from './modals/common-alert.js'
import { getEmails, updateCategry, getCounts } from '../helper/apiHelper.js';
import { svg } from '../assets/svg/common.js';
import { deleteEmails } from '../helper/emailHelper.js';
import { useLoading } from '../context/LoadingContext';

const Sidebar = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeCategory, setActiveCategory] = useState(null);
    const [isCategoryOpen, setIsCategoryOpen] = useState(true);
    const [isQuickOpen, setIsQuickOpen] = useState(true);
    const [isQuickSent, setIsQuickSent] = useState(false);
    const [isCategry, setIsCategry] = useState(false);
    const [quickSent, setQuickSent] = useState([]);
    const [heightToEnd, setHeightToEnd] = useState(0);
    const [userName, setUserName] = useState('');
    const [hoveredQuickIndex, setHoveredQuickIndex] = useState(null);
    const [hoveredCategoryIndex, setHoveredCategoryIndex] = useState(null);
    const [categoryList, setCategoryList] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const { showLoader, hideLoader } = useLoading();
    const sideBodyRef = useRef(null);
    const dispatch = useDispatch();
    const history = useNavigate();
    const isCompose = useSelector((state) => state.isCompose);
    const refreshMessage = useSelector((state) => state.refreshMessage);
    const refreshCount = useSelector((state) => state.refreshCount);

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        setUserName(user.wallet.username)
        getQuickSentList();
        getcategoryList();
        getEmailCounts();
        const updateHeight = () => {
            setTimeout(() => calculateHeight(), 100);
        };
        updateHeight();
        window.addEventListener('resize', updateHeight);

        return () => {
            window.removeEventListener('resize', updateHeight);
        };
    }, []);

    const calculateHeight = () => {
        if (sideBodyRef.current) {
            const messageSectionTop = sideBodyRef.current.getBoundingClientRect().top;
            const heightToEnd = window.innerHeight - messageSectionTop;
            setHeightToEnd(heightToEnd);
        }
    };

    const getQuickSentList = async () => {
        const user = JSON.parse(localStorage.getItem('user'));
        const data = await getEmails(user.wallet.username, 'quickSent');
        const formatedList = data.res.map((item) => {
            return {
                id: item.id,
                name: item.email.split('@')[0],
                email: item.email
            }
        })
        setQuickSent(formatedList);
    }

    const getcategoryList = async () => {
        const user = JSON.parse(localStorage.getItem('user'));
        const data = await getEmails(user.wallet.username, 'categoryList');
        setCategoryList(data.res || []);
    }

    useEffect(() => {
        window.addEventListener('REFRESH_COUNT', fetchEmailList);
        return () => {
            window.removeEventListener('REFRESH_COUNT', fetchEmailList);
        };
    }, []);

    const fetchEmailList = () => {
        getQuickSentList();
        getcategoryList();
        getEmailCounts();
    }

    useEffect(() => {
        fetchEmailList()
    }, [refreshMessage, refreshCount]);

    const getEmailCounts = async () => {
        const res = await getCounts();
        if (res) {
            setUnreadCount(res.unread_count);
            dispatch({ type: "count_update", payload: res.unread_count })
        }
    }

    const deleteQuickSent = async (id) => {
        showLoader();
        await deleteEmails('quicksent', [id]);
        dispatch({ type: "REFRESH_MESSAGE", payload: !refreshMessage })
        hideLoader();
    }

    const deleteCategory = async (id) => {
        showLoader();
        await deleteEmails('delete_category', [id]);
        dispatch({ type: "REFRESH_MESSAGE", payload: !refreshMessage })
        hideLoader();
    }

    const handleActiveCategory = (index) => {
        setActiveCategory(index);
        setActiveIndex(null);
    }

    const handleActiveindex = (index) => {
        setActiveCategory(null);
        setActiveIndex(index);
    }

    const handleDrop = async (e, category) => {
        e.preventDefault();
        const messageId = e.dataTransfer.getData('message_id');
        if (messageId) {
            showLoader();
            await updateCategry(messageId, category.id);
            hideLoader();
        }
    };

    const allowDrop = (e) => {
        e.preventDefault();
    };

    return (
        <div className="sidebar-section overflow-x-hidden">
            <div className='securus-logo d-flex justify-content-center align-items-center'>
                <span>{logo.log_plus_text}</span>
            </div>
            <div className='sidebar-open-close-section'>
                <span className='open-close-arrow cursor-pointer'>
                    <span className='mt-2'>{sidebar_svg.left_arrow}</span>
                </span>
            </div>
            <span className='side-bar-user-name'>{userName}</span>
            <div className='compose-section mt-1 d-flex justify-content-center align-items-center'>
                <button className='compose-btn' onClick={async () => {
                    if (isCompose) return;
                    clearComposeBox();
                    dispatch({ type: "IS_COMPOSE", payload: true });
                }}>{sidebar_svg.compose_svg} <span className='compose-btn-text'>Compose</span></button>
            </div>
            <div className='sidebar-scrool-section' ref={sideBodyRef} style={{ height: `${heightToEnd}px` }}>
                <div className='sidebar-menu-section mt-4 d-flex flex-column '>
                    {menus.map((menu, index) => (
                        <Link to={menu.path} key={index}><div className={`row sidebar-menu position-relative cursor-pointer d-flex justify-content-center align-items-center ${activeIndex === index ? 'active' : ''}`} key={index} onClick={() => {
                            handleActiveindex(index);
                        }}>
                            <span className='col-1'>
                                {activeIndex === index ? <div className="dummy-border-append"> </div> : ''}
                            </span>
                            <span className='col-1'>{activeIndex === index ? menu.active_icon : menu.icon}</span>
                            <span className='col ps-4'><span className='menu-text'>{menu.name}</span></span>
                            <span className='col d-flex justify-content-evenly gap-2 align-items-center' onClick={() => {
                                dispatch({ type: "REFRESH_MESSAGE", payload: !refreshMessage })
                            }}>
                                {activeIndex === index ? (<span>{sidebar_svg.reload}</span>) : <span></span>}
                                {unreadCount > 0 && menu.name === 'Inbox' && <span className='count-text'>{unreadCount}</span>}
                            </span>
                        </div>
                        </Link>
                    ))}
                </div>
                <span className='border-section d-flex justify-content-center'>
                    <hr className='width-90' />
                </span>
                <div className='category-section mt-2'>
                    <div className='category-header d-flex justify-content-between align-items-center ps-2'>
                        <span className='category-header-text'>CATEGORIES</span>
                        <span className='category-header-arrow cursor-pointer' style={{ rotate: isCategoryOpen ? '180deg' : '' }} onClick={() => { setIsCategoryOpen(!isCategoryOpen) }}>{sidebar_svg.up_arrow}</span>
                    </div>
                    {isCategoryOpen &&
                        <div className='category-list-section'>
                            {categoryList.map((category, index) => (
                                <div className={`category-list height-3rem cursor-pointer d-flex justify-content-between align-items-center ${activeCategory === index ? 'active' : ''}`} key={index} onMouseEnter={() => setHoveredCategoryIndex(index)}
                                    onMouseLeave={() => setHoveredCategoryIndex(null)} onClick={() => {
                                        dispatch({ type: "ACTIVE_CATEGORY_iD", payload: category.id });
                                        handleActiveCategory(index);
                                        history("/category");
                                    }} onDrop={(e) => {
                                        handleDrop(e, category)
                                    }}
                                    onDragOver={allowDrop}>
                                    <span className='d-flex justify-content-center gap-2 align-items-center'>
                                        {/* <span className='category-list-icon'>.</span> */}
                                        <span className='category-list-text ps-2'>{category.category_name}</span>
                                    </span>
                                    {hoveredCategoryIndex === index &&
                                        <span onClick={async (e) => {
                                            e.stopPropagation();
                                            await deleteCategory(category.id);
                                        }}>{svg.delete}</span>
                                    }
                                </div>
                            ))}
                        </div>
                    }
                    <div className='new-quick-section d-flex align-items-center gap-2 ps-3 mt-3 cursor-pointer' onClick={() => {
                        setIsCategry(true);
                    }}>
                        <div className='plus-icon cursor-pointer'>{sidebar_svg.plus}</div>
                        <div className='category-list-text'>Add Category</div>
                    </div>
                </div>
                <span className='border-section d-flex justify-content-center'>
                    <hr className='width-90' />
                </span>
                <div className='quick-section'>
                    <div className='category-header d-flex justify-content-between align-items-center ps-2'>
                        <span className='category-header-text'>QUICK SEND</span>
                        <span className='category-header-arrow cursor-pointer' style={{ rotate: isQuickOpen ? '180deg' : '' }} onClick={() => { setIsQuickOpen(!isQuickOpen) }}>{sidebar_svg.up_arrow}</span>
                    </div>
                    {isQuickOpen &&
                        <div className='quick-list-section'>
                            {quickSent.map((quick, index) => (
                                <div className='category-list d-flex justify-content-between align-items-center cursor-pointer' key={index} onClick={() => {
                                    if (isCompose) return;
                                    clearComposeBox();
                                    localStorage.setItem('recipient', quick.email);
                                    dispatch({ type: "IS_COMPOSE", payload: true });
                                    const event = new CustomEvent('clickQuickSent', { email: quick.email });
                                    window.dispatchEvent(event);
                                }} onMouseEnter={() => setHoveredQuickIndex(index)}
                                    onMouseLeave={() => setHoveredQuickIndex(null)}>
                                    <span className='d-flex justify-content-between gap-2 align-items-center'><span className="user-profile-pic cursor-pointer">{quick.name.charAt(0).toUpperCase() || '#'}</span>
                                        <div className='quick-email-section d-flex flex-column gap-2'>
                                            <div className='category-list-text'>{quick.name}</div>
                                            <div className='quick-list-text text-truncate'>{quick.email}</div>
                                        </div>

                                    </span>
                                    {hoveredQuickIndex === index &&
                                        <span onClick={async (e) => {
                                            e.stopPropagation();
                                            await deleteQuickSent(quick.id);
                                        }}>{svg.delete}</span>
                                    }
                                </div>
                            ))}
                        </div>
                    }
                </div>
                <div className='new-quick-section d-flex align-items-center gap-2 ps-3 mt-3 cursor-pointer mb-2' onClick={() => {
                    setIsQuickSent(true);
                }}>
                    <div className='plus-icon cursor-pointer'>{sidebar_svg.plus}</div>
                    <div className='category-list-text'>Add New</div>
                </div>
            </div>
            {isQuickSent &&
                <QuickSent isOpen={isQuickSent} close={() => { setIsQuickSent(false) }} quickUserList={quickSent} />
            }
            {isCategry &&
                <Category isOpen={isCategry} close={() => { setIsCategry(false) }} categryList={categoryList} />
            }
        </div>
    );
};

export default Sidebar;